import React from 'react'

function ListContactContainer() {
    return <section className="ListCustomersContainer"></section>
}

export default ListContactContainer
